import React from 'react'
import bannerCabecera from '../../imagenes/sobrePedraza/bg-sobre-pedraza.jpg'
import bannerCabecera2x from '../../imagenes/sobrePedraza/bg-sobre-pedraza@2x.jpg'


const Sucursales = (props) => {

  window.scrollTo(0,0);

  return (
    <section>
    <section className="sobre-pedraza">
    <div className="container-fluid">
      <div className="row">
        <div className="bg col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <img src={bannerCabecera} alt="Imagen de un avi&oacute;n despegando"
            srcSet={bannerCabecera + ' 1x, ' + bannerCabecera2x + ' 2x'} />
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

            <h1>Nuestras Sucursales</h1>
            <hr />
            <div className="sucursal col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
              <h6>Buenos Aires</h6>
              <p>Florida 537 Piso 8 - Galer&iacute;a Jard&iacute;n - CABA, Bs As (C.P. C1005AAK)
                <br />Tel: 011 - 4105 - 2100
                <br />Atencion Presencial: Lunes a Viernes: de 9:30 a 14:00 hs.y de 15:00 a 18:30 hs.
                <br />Atencion telefonica: Lunes a Viernes de 8:00 a 00:00 hs. 
                <br />Sábado, Domingo y Feriados: Solo atención Telefónica de 10:00 a 18:00 hs.
                {/* <br />Domingo: Solo atención Telefónica de 10:00 a 14:00 hs. */}
              </p>
              <section className="oficina">
              <div className="container">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 map-container">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3284.0980924729834!2d-58.37748504951153!3d-34.60168098036405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccacc6871eb61%3A0x221547b8ff109e06!2sPedraza+Viajes+y+Turismo!5e0!3m2!1ses!2sar!4v1524351448972"
                      frameBorder="0" style={{border: 0}} allowFullScreen title="Ubicacion de Pedraza"></iframe>
                  </div>
                </div>
              </div>
              </section>
            </div>

          <div className="sucursal col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
            <h6>Rosario</h6>
            <p>Corrientes 631 - Piso 6 Of. "C" - Edificio Foss II - Rosario
              <br />Tel: 0810-122-7337
              <br />Atencion Presencial: Lunes a Viernes: de 9:30 a 14:00 hs.y de 15:00 a 18:30 hs.
              <br />Atencion telefonica: Lunes a Viernes de 8:00 a 00:00 hs. 
              <br />Sábado, Domingo y Feriados: Solo atención Telefónica de 10:00 a 18:00 hs.
               {/*  <br />Domingo: Solo atención Telefónica de 10:00 a 14:00 Hs. */}
            </p>
            <section className="oficina">
            <div className="container">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 map-container">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.1677373522994!2d-60.63915428426468!3d-32.94658057921612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ab1974e86b75%3A0x74e87c75b22651e3!2sPedraza+Viajes+y+Turismo!5e0!3m2!1ses!2sar!4v1533838732604"
                    frameBorder="0" style={{border: 0}} allowFullScreen title="Ubicacion de Pedraza"></iframe>
                </div>
              </div>
            </div>
            </section>
          </div>

        </article>
      </div>
    </div>
    </section>
    </section>
  )
}

export default Sucursales



// WEBPACK FOOTER //
// ./src/components/Global/Sucursales.js